import { useIntl } from 'react-intl';
import { ProductAmount, ProductData } from 'types/ProductData';
import { StyledStickyAddToCart } from './style';
import { Button } from 'ui';
import { FallbackImage } from 'ui/UploadImage/fallBack/FallBackImage';
import AmountSelector from 'ui/CartAmountSelector/CartAmountSelector';
import { ProductUnityPrice, ProductPrice } from 'utils/productCardHelpers';
import { useBreakpoint } from 'utils/useBreakpoint';
import useMarketType from 'utils/useMarketType';
import { options } from 'config/config';

const DEFAULT_IMAGE = options.images.defaultProductImage;

interface StickyAddToCartProps {
  product?: ProductData;
  productAmount?: ProductAmount;
  productHasDiscount: boolean;
  amountCart: number;
  visible: boolean;
  onAddToCart: () => void;
}

const StickyAddToCart = ({
  product,
  productAmount,
  productHasDiscount,
  amountCart,
  visible,
  onAddToCart,
}: StickyAddToCartProps) => {
  const intl = useIntl();
  const { isXsUp } = useBreakpoint();
  const { isEmarket } = useMarketType();

  return (
    <StyledStickyAddToCart
      className={`${visible ? 'visible' : ''}${!isEmarket ? ' wholesale' : ''}`}
    >
      <div className={'sticky-cart-container'}>
        <div className={'sticky-cart-product'}>
          <FallbackImage
            src={
              product?.image_small
                ? product?.image_small
                : product?.farm?.logo
                  ? product?.farm?.logo
                  : DEFAULT_IMAGE
            }
            type={'ProductCard'}
            preview={false}
          />
          <div className={'sticky-cart-name'}>{product?.name}</div>
        </div>
        <div className={'sticky-cart-actions'}>
          <div className={'price-main d-flex flex-col'}>
            <ProductUnityPrice productAmount={productAmount} />
            <ProductPrice
              productAmount={productAmount}
              productHasDiscount={productHasDiscount}
              amount={amountCart}
            />
          </div>
          {amountCart === 0 ? (
            <Button
              type={'primary'}
              className={'sticky-add-btn'}
              label={intl.formatMessage({
                id: isXsUp
                  ? 'button.addToCartDesktop'
                  : 'button.addToCartMobile',
              })}
              onClick={onAddToCart}
            />
          ) : (
            <AmountSelector
              product={product}
              unitType={productAmount?.storage_unit}
              amountCart={amountCart}
              className={'productView'}
            />
          )}
        </div>
      </div>
    </StyledStickyAddToCart>
  );
};

export default StickyAddToCart;
